export default "__VITE_ASSET__CWtdeBHX__"